import {
  Button,
  Card,
  CardActionArea,
  CardContent,
  Container,
  FormControl,
  Grid,
  Input,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  Snackbar,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";

const useStyles = makeStyles((theme) => ({
  mt24: {
    marginTop: 24,
  },
}));

// const serverConfiguration = {
//   iceServers: [
//     {
//       urls: ["stun:stun.l.google.com:19302", "stun:74.125.142.127:19302"],
//     },
//     {
//       urls: ["turn:numb.viagenie.ca"],
//       username: "[email]",
//       credential: "[password]",
//     },
//   ],
// };

const serverConfiguration = {
  iceServers: [
    {
      urls: "stun:stun.l.google.com:19302",
    },
    {
      urls: "turn:numb.viagenie.ca",
      username: "abhi.kohokade@gmail.com",
      credential: "abhi.kohokade@gmail.com",
    },
  ],
  iceCandidatePoolSize: 10,
};

const constraints = (window.constraints = {
  audio: false,
  video: true,
});
const offerOptions = {
  offerToReceiveAudio: 1,
  offerToReceiveVideo: 1,
};
const Testing = () => {
  const classes = useStyles();
  const videoRef = useRef(null);
  const videoRemoteRef = useRef(null);
  const [msg, setMsg] = useState("");
  const [snack, setSnack] = useState(false);
  const [vinput, setVInput] = useState([]);
  const [vSelected, setVSelected] = useState("");
  const [localStream, setLocalStream] = useState("");
  //   const [pc1, setPc1] = useState("");
  //   const [pc2, setPc2] = useState("");
  let pc1;
  let pc2;
  function closeSnack() {
    setSnack(false);
  }

  useEffect(() => {
    videoRef.current.addEventListener("loadedmetadata", function () {
      // console.log(
      //   `Local video videoWidth: ${this.videoWidth}px,  videoHeight: ${this.videoHeight}px`
      // );
    });
  }, []);
  //   /** this function is for simple use */
  //   function handleSuccess(stream) {
  //     const videoTracks = stream.getVideoTracks();
  //     // console.log("Got stream with constraints:", constraints);
  //     // console.log(`Using video device: ${videoTracks[0].label}`);
  //     window.stream = stream;
  //     // console.log("stream " + stream.getVideoTracks());
  //     // console.log(videoRef);
  //     videoRef.current.srcObject = stream;
  //   }

  function handleError(error) {
    if (error.name === "ConstraintNotSatisfiedError") {
      const v = constraints.video;
      errorMsg(
        `The resolution ${v.width.exact}x${v.height.exact} px is not supported by your device.`
      );
    } else if (error.name === "PermissionDeniedError") {
      errorMsg(
        "Permissions have not been granted to use your camera and " +
          "microphone, you need to allow the page access to your devices in " +
          "order for the demo to work."
      );
    }
    errorMsg(`getUserMedia error: ${error.name}`, error);
  }

  function errorMsg(msgg, error) {
    setMsg(error.message);
    setSnack(true);
  }

  async function askPermission() {
    const constraints = (window.constraints = {
      audio: true,
      video: {
        deviceId: vSelected ? { exact: vSelected } : undefined,
      },
    });
    try {
      const stream = await navigator.mediaDevices
        .getUserMedia(constraints)
        .then(gotStream)
        .then(gotDevices);
      //   handleSuccess(stream);
    } catch (e) {
      handleError(e);
    }
  }

  function toggleCamera() {
    if (window.stream) {
      window.stream.getTracks().forEach((track) => {
        track.stop();
      });
    }
    askPermission();
  }

  function gotStream(stream) {
    window.stream = stream; // make stream available to console
    videoRef.current.srcObject = stream;
    // Refresh button list in case labels have become available
    setLocalStream(stream);
    return navigator.mediaDevices.enumerateDevices();
  }

  const gotDevices = (deviceInfos) => {
    setVInput([]);
    deviceInfos.forEach(function (device) {
      if (device.kind === "videoinput") {
        // console.log(JSON.stringify(device));
        setVInput((old) => [...old, device]);
      }
    });
  };

  async function call() {
    const videoTracks = localStream.getVideoTracks();
    const audioTracks = localStream.getAudioTracks();
    if (videoTracks.length > 0) {
      console.log("videoTrack " + videoTracks[0].label);
    }
    if (audioTracks.length > 0) {
      console.log("videoTrack " + audioTracks[0].label);
    }

    pc1 = new RTCPeerConnection(serverConfiguration);
    pc2 = new RTCPeerConnection(serverConfiguration);

    pc1.onicecandidate = async (event) => {
      try {
        console.log(JSON.stringify(event.candidate));
        if (event.candidate !== null)
          await pc2.addIceCandidate(event.candidate);
      } catch (e) {
        console.log("E : pc2.addIceCandidate " + e.message);
      }
    };

    pc2.onicecandidate = async (event) => {
      try {
        if (event.candidate !== null)
          await pc1.addIceCandidate(event.candidate);
      } catch (e) {
        console.log("E pc1.addIceCandidate " + e.message);
      }
    };

    pc1.oniceconnectionstatechange = (e) => onIceStateChange(pc1, e);
    pc2.oniceconnectionstatechange = (e) => onIceStateChange(pc2, e);

    pc2.ontrack = gotRemoteStream;

    localStream
      .getTracks()
      .forEach((track) => pc1.addTrack(track, localStream));

    try {
      const offer = await pc1.createOffer(offerOptions);
      await onCreateOfferSuccess(offer);
    } catch (e) {}
  }

  async function onCreateOfferSuccess(desc) {
    try {
      await pc1.setLocalDescription(desc);
    } catch (e) {
      console.log("E pc1.setLocalDescription" + e.message);
    }

    try {
      await pc2.setRemoteDescription(desc);
    } catch (e) {
      console.log("E pc2.setRemoteDescription" + e.message);
    }

    try {
      const answer = await pc2.createAnswer();
      await onCreateAnswerSuccess(answer);
    } catch (e) {
      console.log("E pc2.createAnswer" + e.message);
    }
  }

  async function onCreateAnswerSuccess(desc) {
    try {
      await pc2.setLocalDescription(desc);
    } catch (e) {
      console.log("E pc2.setLocalDescription" + e.message);
    }
    try {
      await pc1.setRemoteDescription(desc);
    } catch (e) {
      console.log("E pc1.setRemoteDescription" + e.message);
    }
  }

  function gotRemoteStream(e) {
    if (videoRemoteRef.current.srcObject !== e.streams[0]) {
      videoRemoteRef.current.srcObject = e.streams[0];
    }
  }
  function onIceStateChange(pc, event) {
    console.log("STATE " + pc.connectionState);
  }

  return (
    <div>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        message={msg}
        open={snack}
        autoHideDuration={6000}
        onClose={closeSnack}
      ></Snackbar>
      <Container className={classes.mt24}>
        <Grid container spacing={2}>
          <Grid item md={4}>
            <Card>
              <CardActionArea>
                <video
                  ref={videoRef}
                  autoPlay
                  muted
                  playsInline
                  width="100%"
                  height="40%"
                ></video>
                <CardContent>
                  <Typography gutterBottom variant="h6">
                    Lizard
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
          <Grid item md={4}>
            <Card>
              <CardActionArea>
                <video
                  ref={videoRemoteRef}
                  autoPlay
                  playsInline
                  width="100%"
                  height="40%"
                ></video>
                <CardContent>
                  <Typography gutterBottom variant="h6">
                    Lizard
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>

          <Grid item md={12}>
            <Button onClick={askPermission} variant="contained" color="primary">
              Access Permission
            </Button>
            &nbsp;&nbsp;
            <Button onClick={call} variant="contained" color="primary">
              Call
            </Button>
            <br />
            <br />
            <FormControl fullWidth>
              <InputLabel htmlFor="age-helper">Video Input</InputLabel>
              <Select
                fullWidth
                value={vSelected}
                onChange={(e) => setVSelected(e.target.value)}
                input={<Input name="age" id="age-helper" />}
              >
                {vinput.map((v, k) => (
                  <MenuItem value={v.deviceId} key={k}>
                    {v.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <br />
            <br />
            <Button onClick={toggleCamera} variant="contained" color="primary">
              Toggle Camera
            </Button>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default Testing;
